import i18n from 'i18n';
import { COMMON_GRID_COLUMN_FIELD_NAMES } from 'shared/commonGrid/grid-enums';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { NetworkId } from 'data/networkId/networkId.types';

export enum NetworkIdActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newNetworkId: NetworkId = {
  networkId: '',
  ownIPAddress: '',
  startPortNumber: '',
  portNumberRange: '',
};

export const distributorColumnDefs: ColDef[] = [

  {
    headerName: i18n.t('networkId.grid.networkId'),
    field: 'networkId',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'Network ID',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('networkId.grid.localIpAddress'),
    field: 'ownIPAddress',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'Local IP Address',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('networkId.grid.startPortNumber'),
    field: 'startPortNumber',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'Starting Port Number',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('networkId.grid.portNumberRange'),
    field: 'portNumberRange',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'Max. Number of Ports',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('networkId.grid.nodeName'),
    field: 'nodeName',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'Node Name',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
];
